import {useDispatch, useSelector} from 'Provider';
import {View} from 'native-base';
import React, {useCallback} from 'react';

import OfferTypesFilterSelector from 'components/Offers/OfferTypesFilterSelector';
import {OfferType} from 'models/Offer';
import {OffersActions} from 'store/offers/offers.reducer';
import {
  availableFiltersSelector,
  selectedFilterSelector,
} from 'store/offers/offers.selectors';

import FilterScreenMobile from './FilterScreenMobile';

const OfferTypesMobile = () => {
  const dispatch = useDispatch();
  const selectedFilters = useSelector(selectedFilterSelector);
  const availableFilters = useSelector(availableFiltersSelector);
  const selectedOfferTypes = selectedFilters.type ?? Object.values(OfferType);
  const setSelectedOfferTypes = useCallback(
    offerTypes =>
      dispatch(OffersActions.setSelectedOfferTypeFilter(offerTypes)),
    [dispatch]
  );

  return (
    <FilterScreenMobile title="OFFER TYPE">
      <View alignItems="center">
        <OfferTypesFilterSelector
          selectedOfferTypes={selectedOfferTypes}
          availableOfferTypes={availableFilters.types}
          setSelectedOfferTypes={setSelectedOfferTypes}
        />
      </View>
    </FilterScreenMobile>
  );
};
export default OfferTypesMobile;
